import React from "react";
import Navbar from "./../../components/Navbar";
import HomePage from "./../home";
import AboutPage from "./../about";
import FaqPage from "./../faq";
import StoryQuiz from "./../story-quiz";
import StoryQuizPreview from "./../story-quiz-preview";
import { Switch, Route, Router } from "./../../util/router.js";
import Footer from "./../../components/Footer";
import "./styles.scss";
import logo from "../../images/logo.svg";
import logoLong from "../../images/logo-long.svg";

function App(props) {
  return (
    <Router>
      <React.Fragment>
        <Navbar color="white" spaced={true} logo={logoLong} />

        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/faq" component={FaqPage} />
          <Route exact path="/story-quiz" component={StoryQuiz} />
          <Route
            exact
            path="/story-quiz-preview"
            component={StoryQuizPreview}
          />
          <Route
            component={({ location }) => {
              return (
                <div
                  style={{
                    padding: "50px",
                    width: "100%",
                    textAlign: "center"
                  }}
                >
                  We couldn't find <code>{location.pathname}</code>, sorry about
                  that.
                </div>
              );
            }}
          />
        </Switch>

        <Footer
          color="light"
          size="normal"
          logo={logo}
          copyright={
            <React.Fragment>
              © Planeteers {new Date().getFullYear()} &mdash;{" "}
              <i>an EndGame waza group</i>
            </React.Fragment>
          }
        />
      </React.Fragment>
    </Router>
  );
}

export default App;
